// extracted by mini-css-extract-plugin
module.exports = {"lrvTooltip":"LrvTooltip_lrvTooltip__2j-5y","darkStyle":"LrvTooltip_darkStyle__NqQ4a","lightStyle":"LrvTooltip_lightStyle__3Sgs3"};